/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteSigintSensorSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteSigintSensorSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteSigintSensorSecurity = {
  option1?: DeleteSigintSensorSecurityOption1 | undefined;
  option2?: DeleteSigintSensorSecurityOption2 | undefined;
};

export type DeleteSigintSensorRequest = {
  /**
   * Sensor ID
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteSigintSensorSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteSigintSensorSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteSigintSensorSecurityOption1$Outbound,
  DeleteSigintSensorSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteSigintSensorSecurityOption1ToJSON(
  deleteSigintSensorSecurityOption1: DeleteSigintSensorSecurityOption1,
): string {
  return JSON.stringify(
    DeleteSigintSensorSecurityOption1$outboundSchema.parse(
      deleteSigintSensorSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteSigintSensorSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteSigintSensorSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteSigintSensorSecurityOption2$Outbound,
  DeleteSigintSensorSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteSigintSensorSecurityOption2ToJSON(
  deleteSigintSensorSecurityOption2: DeleteSigintSensorSecurityOption2,
): string {
  return JSON.stringify(
    DeleteSigintSensorSecurityOption2$outboundSchema.parse(
      deleteSigintSensorSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteSigintSensorSecurity$Outbound = {
  Option1?: DeleteSigintSensorSecurityOption1$Outbound | undefined;
  Option2?: DeleteSigintSensorSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteSigintSensorSecurity$outboundSchema: z.ZodMiniType<
  DeleteSigintSensorSecurity$Outbound,
  DeleteSigintSensorSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteSigintSensorSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteSigintSensorSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteSigintSensorSecurityToJSON(
  deleteSigintSensorSecurity: DeleteSigintSensorSecurity,
): string {
  return JSON.stringify(
    DeleteSigintSensorSecurity$outboundSchema.parse(deleteSigintSensorSecurity),
  );
}

/** @internal */
export type DeleteSigintSensorRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteSigintSensorRequest$outboundSchema: z.ZodMiniType<
  DeleteSigintSensorRequest$Outbound,
  DeleteSigintSensorRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteSigintSensorRequestToJSON(
  deleteSigintSensorRequest: DeleteSigintSensorRequest,
): string {
  return JSON.stringify(
    DeleteSigintSensorRequest$outboundSchema.parse(deleteSigintSensorRequest),
  );
}
